import { BottomSheet } from "@base/ui/BottomSheet";
import type { WorkHistoryTabKey } from "./WorkHistoryDayContent";
import { WorkHistoryDayContent } from "./WorkHistoryDayContent";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  date: string;
  projectId: string;
  activeTab: WorkHistoryTabKey;
  onActiveTabChange: (tab: WorkHistoryTabKey) => void;
  /** 선택 날짜의 실제 일지 id (없으면 null). "Open daily log" 이동에 쓴다. */
  dailyLogId: number | null;
};

/**
 * <1280px에서 선택 날짜 상세를 보여주는 sheet. 내용은 `WorkHistoryDayContent`로,
 * desktop 우측 panel과 완전히 같은 컴포넌트·query를 공유한다 (TRD §7.5).
 */
export function WorkHistoryBottomSheet({
  isOpen,
  onClose,
  date,
  projectId,
  activeTab,
  onActiveTabChange,
  dailyLogId,
}: Props) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} maxHeight={100}>
      <div className="px-4 pb-4">
        <WorkHistoryDayContent
          projectId={projectId}
          date={date}
          activeTab={activeTab}
          onActiveTabChange={onActiveTabChange}
          onClose={onClose}
          dailyLogId={dailyLogId}
        />
      </div>
    </BottomSheet>
  );
}
